<script setup lang="ts">
  // [NOTE] This component maps the value of the "WeatherIcon" field, from the Accuweather
  // API response, to an SVG file. The possible values for that field can be found on:
  // https://developer.accuweather.com/weather-icons.
  //

  interface Props {
    icon: number
  }

  const props = defineProps<Props>()
  const getIcon = async (icon: number) => {
    switch (icon) {
      case 1:
        return import(/* @vite-ignore */ '../assets/weather/sunny.svg?raw')
      case 2:
        return import(/* @vite-ignore */ '../assets/weather/mostly_sunny.svg?raw')
      case 3:
        return import(/* @vite-ignore */ '../assets/weather/partly_sunny.svg?raw')
      case 4:
        return import(/* @vite-ignore */ '../assets/weather/intermittent_clouds_day.svg?raw')
      case 5:
        return import(/* @vite-ignore */ '../assets/weather/hazy_sunshine.svg?raw')
      case 6:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_day.svg?raw')
      case 7:
        return import(/* @vite-ignore */ '../assets/weather/cloudy.svg?raw')
      case 8:
        return import(/* @vite-ignore */ '../assets/weather/dreary.svg?raw')
      case 11:
        return import(/* @vite-ignore */ '../assets/weather/fog.svg?raw')
      case 12:
        return import(/* @vite-ignore */ '../assets/weather/showers.svg?raw')
      case 13:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_with_showers_day.svg?raw')
      case 14:
        return import(/* @vite-ignore */ '../assets/weather/partly_sunny_with_showers.svg?raw')
      case 15:
        return import(/* @vite-ignore */ '../assets/weather/tstorms.svg?raw')
      case 16:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_with_tstorms_day.svg?raw')
      case 17:
        return import(/* @vite-ignore */ '../assets/weather/partly_sunny_with_tstorms.svg?raw')
      case 18:
        return import(/* @vite-ignore */ '../assets/weather/rain.svg?raw')
      case 19:
        return import(/* @vite-ignore */ '../assets/weather/flurries.svg?raw')
      case 20:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_with_flurries_day.svg?raw')
      case 21:
        return import(/* @vite-ignore */ '../assets/weather/partly_sunny_with_flurries.svg?raw')
      case 22:
        return import(/* @vite-ignore */ '../assets/weather/snow.svg?raw')
      case 23:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_with_snow_day.svg?raw')
      case 24:
        return import(/* @vite-ignore */ '../assets/weather/ice.svg?raw')
      case 25:
        return import(/* @vite-ignore */ '../assets/weather/sleet.svg?raw')
      case 26:
        return import(/* @vite-ignore */ '../assets/weather/freezing_rain.svg?raw')
      case 29:
        return import(/* @vite-ignore */ '../assets/weather/rain_and_snow.svg?raw')
      case 30:
        return import(/* @vite-ignore */ '../assets/weather/hot.svg?raw')
      case 31:
        return import(/* @vite-ignore */ '../assets/weather/cold.svg?raw')
      case 32:
        return import(/* @vite-ignore */ '../assets/weather/windy.svg?raw')
      case 33:
        return import(/* @vite-ignore */ '../assets/weather/clear.svg?raw')
      case 34:
        return import(/* @vite-ignore */ '../assets/weather/mostly_clear.svg?raw')
      case 35:
        return import(/* @vite-ignore */ '../assets/weather/partly_cloudy.svg?raw')
      case 36:
        return import(/* @vite-ignore */ '../assets/weather/intermittent_clouds_night.svg?raw')
      case 37:
        return import(/* @vite-ignore */ '../assets/weather/hazy_moonlight.svg?raw')
      case 38:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_night.svg?raw')
      case 39:
        return import(/* @vite-ignore */ '../assets/weather/partly_cloudy_with_showers.svg?raw')
      case 40:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_with_showers_night.svg?raw')
      case 41:
        return import(/* @vite-ignore */ '../assets/weather/partly_cloudy_with_tstorms.svg?raw')
      case 42:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_with_tstorms_night.svg?raw')
      case 43:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_with_flurries_night.svg?raw')
      case 44:
        return import(/* @vite-ignore */ '../assets/weather/mostly_cloudy_with_snow_night.svg?raw')
    }
  }

  const dynamicSVG = (await getIcon(props.icon))?.default
</script>
<template>
  <div v-html="dynamicSVG" />
</template>
